import type { ActionExecutor } from "../TriggerEngine.interfaces";

export const webhook: ActionExecutor = async (_radio, config) => {
  let url: URL;

  try {
    url = new URL(config?.url?.trim());
  } catch {
    throw new Error("A valid HTTP(S) webhook URL is required");
  }

  if (url.protocol !== "http:" && url.protocol !== "https:") {
    throw new Error("A valid HTTP(S) webhook URL is required");
  }

  const controller = new AbortController();
  const timeout = setTimeout(() => {
    controller.abort(new Error("Webhook request timed out"));
  }, 15000);

  try {
    const response = await fetch(url.toString(), {
      method: "POST",
      mode: "no-cors",
      signal: controller.signal,
    });

    // Cross-origin no-cors responses are opaque, so their status is unavailable.
    if (response.type !== "opaque" && !response.ok) {
      throw new Error(`Webhook request failed (${response.status})`);
    }
  } finally {
    clearTimeout(timeout);
  }
};
